import {
  UserSettingsAuthProviders,
  UserSettingsGeneral,
} from '@backstage/plugin-user-settings';
import {
  FullPage,
  MaterialIcon,
  PageHeader,
} from '@dewise-devex/backstage-plugin-mui-uikit-react';
import React from 'react';

export const SettingsHomePage: React.FC = () => {
  return (
    <FullPage
      variant="card"
      HeaderComponent={() => (
        <PageHeader title="Settings" icon={<MaterialIcon.SettingsRounded />} />
      )}
    >
      <UserSettingsGeneral />
      <UserSettingsAuthProviders />
    </FullPage>
  );
};
